import React from 'react'
import { ImageComp } from '../../../Components/ImageCompo/ImageComp'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp'
import { Link } from 'react-router-dom'

const ErrorMessage = ({ openModal, searchKey }) => {
  return (
    <>
      <div className='flex flex-col gap-[20px] h-[50vh] items-center'>
        <ImageComp source='./Images/Search.png' className='object-cover h-[100px] w-[100px]' />
        <ParagraphComp className=' text-center text-2xl text-black' >
          So sorry, no results found for your search criteria <br />
          "{searchKey || ''}" !
        </ParagraphComp>
        <ParagraphComp className=' text-md text-center' >
          Please use the Advanced Search Filters to refine or expand your search criteria.
          <br />
          If you need further help, please <Link className='underline' to='/contact' >
            contact us!
          </Link></ ParagraphComp>
        {/* <ButtonComp onClick={openModal} className='px-[40px] py-[2px] text-[12px]  rounded-full bg-[#004878] text-[white]' text='Try Advanced Search' /> */}
      </div>
    </>
  )
}

export default ErrorMessage